module.exports = __webpack_public_path__ + "static/media/homepage-reports.95c79bd5.svg";